import styled from 'styled-components';
import { space } from 'shared';
import BellNotification from 'components/BellNotification';
import { device } from 'styles/device';

export const StyledBellNotification = styled(BellNotification)`
  margin-right: ${space(10)};
  @media ${device.mobile} {
    background-color: ${({ isUserDropdownOpen }) => isUserDropdownOpen && 'unset'};
    position: ${({ isUserDropdownOpen }) => isUserDropdownOpen && 'absolute'};
  }
`;
